module.exports = __webpack_public_path__ + "img/lovevda.fcf09db0.jpg";